import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Loader from '../../components/Loader/Loader';
import api from '../../api/index.js';
import s from './Characteristics.module.scss';

const REASON_LABELS = {
  conflict: 'Разные значения от поставщиков',
  missing_required: 'Не хватает обязательного поля',
};

const SUPPLIER_LABELS = {
  api_equip: 'Equip',
  api_td: 'TD',
  api_bio: 'Bio',
  api_klen: 'Klen',
  api_practika: 'Practika',
  api_foodatlas: 'Foodatlas',
  api_rusholod: 'Rusholod',
  api_hualian: 'Hualian',
  api_the_matrix: 'The Matrix',
};
const supplierLabel = (api) => SUPPLIER_LABELS[api] || api;

const CategoryExceptions = () => {
  const { cat_id } = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const data = await api.characteristics.getCategoryExceptions(cat_id);
    if (!data.error) {
      setItems(data.items || []);
      setTotal(data.total || 0);
    }
    setLoading(false);
  }, [cat_id]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <Header
        title="Товары, требующие проверки"
        breadCrumbs={[
          { name: 'Характеристики', link: '/characteristics' },
          { name: 'Категория', link: `/characteristics/categories/${cat_id}` },
          { name: 'Проблемы', link: '' },
        ]}
      />

      <div className={s.wrap}>
      <p className={s.lead}>
        Здесь только товары, где что-то пошло не так: нет обязательной характеристики или поставщики дали разные значения.
        Большинство товаров сюда не попадает.
      </p>

      <div className={s.actionsBar}>
        <button className="btn grey" onClick={() => navigate(`/characteristics/categories/${cat_id}`)}>
          ← Назад к категории
        </button>
      </div>

      {loading && <Loader />}
      {!loading && total === 0 && (
        <p className={s.empty}>Всё хорошо — проблемных товаров нет.</p>
      )}
      {!loading && total > 0 && (
        <>
          <p className={s.total}>Товаров: {total}</p>
          <ul className={s.list}>
            {items.map((item) => (
              <li key={item.good_id} className={s.row}>
                <div className={s.rowMain}>
                  <strong>{item.title || item.good_id}</strong>
                  <button
                    className="btn grey small"
                    onClick={() => navigate(`/characteristics/products/${item.good_id}`)}
                  >
                    Открыть
                  </button>
                </div>
                {(item.reason || []).map((r) => (
                  <div key={r} className={s.sub}>{REASON_LABELS[r] || r}</div>
                ))}
                {item.conflicts?.length > 0 && (
                  <div className={s.sub}>
                    {item.conflicts.map((c) => (
                      <span key={c.code}>
                        {c.title || c.code}:{' '}
                        {c.candidates?.map((x) => `${supplierLabel(x.api_name)} ${x.value}`).join(' ≠ ')}
                      </span>
                    ))}
                  </div>
                )}
                {item.missing_required?.length > 0 && (
                  <div className={s.sub}>
                    Нет: {item.missing_required.join(', ')}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </>
      )}
      </div>
    </>
  );
};

export default CategoryExceptions;
